import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

const { FEEDBACK } = PRODUCT_AREAS || {};
const { GENERAL } = SUB_PRODUCT_AREAS || {};

export function feedbackRequestAggregation () {
    const pipeline = o.pipeline(o.sources.feedbackRequests({ appId: 'expandAppIds("*")' }));

    return o.aggregation(
        {
            name: 'feedback-requests',
            productArea: FEEDBACK,
            subProductArea: GENERAL,
        },
        pipeline,
    );
}
